/**
 * Created by jlamy on 2/8/2018
 */
angular.module('comcast.common.communication').factory('MarketResourceFactory', ['$resource', 'EndPointService', 'NotificationInterceptor', function ($resource, ResourceEndPointService, NotificationInterceptor) {
  'use strict';

  return $resource(ResourceEndPointService.marketEndPoint + '/:id', {
    id: '@id'
  }, {
    save: {
      method: 'POST',
      isArray: false,
      interceptor: new NotificationInterceptor().setObject('markets').setAction('Saving')
    },
    getAll: {
      method: 'GET',
      isArray: true,
      interceptor: new NotificationInterceptor().setObject('markets').setAction('Retrieving'),
      cancellable: true
    }
  });
}]);